import React, { useState, useRef, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import PageTitle from "../../../layouts/PageTitle";
import PaginationButtons from "../../../Custom/Pagination";
import { POST_AdminEquipmentInstallationList } from "../../../Helper/url_helper";
import { post } from "../../../Helper/api_helper";
import { t } from "i18next";
import { Spin } from "antd";
import swal from "sweetalert";
import ModalOrderBookingDetail from "../../../Custom/ModalOrderBookingDetail";

const EquipmentInstallation = () => {
  const [recordCount, setRecordCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [photoModal, setPhotodModal] = useState(false);
  const [orderDetailModal, setOrderDetailModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [orderBookingID, setOrderBookingID] = useState("");

  const [equipmentInstallationList, setEquipmentInstallationList] = useState(
    []
  );

  const [equipmentPhotos, setEquipmentPhotos] = useState([]);

  const [searchValue, setSearchvalue] = useState("");
  let updatedSearchValue = searchValue;

  var objLogin = JSON.parse(localStorage.getItem("userDetails"));

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    let response = await post(POST_AdminEquipmentInstallationList, {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: updatedSearchValue,
      Sorting: "",
      CompanyID: objLogin.CompanyIDEncrypt,
      FromDate: "",
      ToDate: "",
    });
    if (response.IsSuccess) {
      setRecordCount(response.TotalRecordCount);
      setEquipmentInstallationList(response.AdminEquipmentInstallationList);
      setCurrentSizePerPage(sizePerPage);
      if (page > 1 && response?.AdminEquipmentInstallationList?.length === 0) {
        setCurrentPage(page - 1);
        getData(page - 1);
      } else {
        setCurrentPage(page);
      }
      setIsLoading(false);
    } else {
      swal("Error!", t(response.MessageCode), "error");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Fragment>
        <Spin size="large" spinning={isLoading} tip={"Loading..."}>
          <PageTitle
            motherMenu="Transaction"
            activeMenu="Equipment Installation"
          />

          <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
            <div className="mr-auto d-lg-block">
              <Link
                to="/add-equipment-installation"
                className="btn btn-primary btn-xs btn-rounded"
              >
                + Add Equipment Installation
              </Link>
            </div>

            <div className="input-group search-area ml-auto d-inline-flex mr-3">
              <input
                type="text"
                style={{ height: "36px" }}
                className="form-control"
                placeholder="Search here"
                value={searchValue}
                onChange={(event) => {
                  updatedSearchValue = event.target.value;
                  setSearchvalue(updatedSearchValue);
                  getData();
                }}
              />
              <div className="input-group-append">
                <button type="button" className="input-group-text">
                  <i className="flaticon-381-search-2" />
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="table-responsive">
                <div id="order_list" className="dataTables_wrapper no-footer">
                  <table
                    id="example5"
                    className="table table-striped patient-list mb-4 dataTablesCard fs-14 dataTable no-footer"
                    role="grid"
                    aria-describedby="example5_info"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Order No: activate to sort column ascending"
                          style={{ width: "10%" }}
                        >
                          Order No.
                        </th>

                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Patient Name: activate to sort column ascending"
                          style={{ width: "25%" }}
                        >
                          Patient Name
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Staff Name: activate to sort column ascending"
                          style={{ width: "20%" }}
                        >
                          Staff Name
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Equipment Name : activate to sort column ascending"
                          style={{ width: "10%" }}
                        >
                          Equipment Name
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Date: activate to sort column ascending"
                          style={{ width: "25%" }}
                        >
                          Date
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Return: activate to sort column ascending"
                          style={{ width: "5%" }}
                        >
                          Return
                        </th>

                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="example5"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Actions: activate to sort column ascending"
                          style={{ width: "5%" }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    {recordCount > 0 ? (
                      <tbody>
                        {equipmentInstallationList?.map((element, i) => (
                          <tr role="row" className="odd">
                            <td style={{ textAlign: "center" }}>
                              {element.OrderBookingNo}
                            </td>
                            <td>{element.PatientName}</td>
                            <td>{element.StaffName}</td>
                            <td>{element.EquipmentName}</td>
                            <td style={{ textAlign: "center" }}>
                              {element.InstallationDate}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {element.ReturnStatus}
                            </td>
                            <td>
                              <div className="d-flex">
                                <Link
                                  // to="/add-equipment-installation"
                                  to={`/edit-equipment-installation/${window.btoa(
                                    element.EquipmentInstallationIDEncrypt
                                  )}`}
                                  className="btn btn-light shadow btn-xs sharp mr-1"
                                  title="Edit"
                                >
                                  <i className="fa fa-pencil"></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-light shadow btn-xs sharp mr-1"
                                  title="Photos"
                                  onClick={() => {
                                    setEquipmentPhotos(
                                      element.AdminEquipmentInstallationPhotosList
                                    );
                                    setPhotodModal(true);
                                  }}
                                >
                                  <i className="fa fa-picture-o"></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-light shadow btn-xs sharp mr-1"
                                  title="Order Detail"
                                  onClick={() => {
                                    setOrderBookingID(
                                      element.OrderBookingIDEncrypt
                                    );
                                    setOrderDetailModal(true);
                                  }}
                                >
                                  <i className="fa fa-eye"></i>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tr>
                        <td colSpan={7}>
                          <div className="mt-3 ml-3">{"No Record Found"}</div>
                        </td>
                      </tr>
                    )}
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <div
                      className="dataTables_info"
                      id="example5_info"
                      role="status"
                      aria-live="polite"
                    >
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <div className="paging_simple_numbers d-flex  justify-content-center align-items-center">
                      <PaginationButtons
                        totalPages={recordCount / currentSizePerPage}
                        currentPage={currentPage}
                        getData={getData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            className="modal fade"
            show={photoModal}
            onHide={setPhotodModal}
            size="lg"
          >
            <div className="modal-header">
              <h4 className="modal-title fs-20">Photos</h4>
              <button
                type="button"
                className="btn close"
                onClick={() => setPhotodModal(false)}
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="pb-1">
                  <div id="lightgallery" className="row">
                    {equipmentPhotos.map((item, index) => (
                      <a
                        // href={item.PhotoUrl}
                        data-exthumbimage={item.PhotoUrl}
                        data-src={item.PhotoUrl}
                        className="col-lg-3 col-md-6 mb-4"
                        key={index}
                      >
                        <img
                          src={item.PhotoUrl}
                          alt=""
                          style={{ width: "100%" }}
                          onClick={() => {
                            window.open(item.PhotoUrl);
                          }}
                        />
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal fade"
            show={orderDetailModal}
            onHide={setOrderDetailModal}
            size="xl"
          >
            <div className="modal-header">
              <h4 className="modal-title fs-20">Order Detail</h4>
              <button
                type="button"
                className="btn close"
                onClick={() => setOrderDetailModal(false)}
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              <ModalOrderBookingDetail
                orderBookingID={orderBookingID}
                setOrderDetailModal={setOrderDetailModal}
              ></ModalOrderBookingDetail>
            </div>
          </Modal>
        </Spin>
      </Fragment>
    </>
  );
};

export default EquipmentInstallation;
